import React from 'react';

interface PopUpProps {
  show: boolean;
}

const PopUp: React.FC<PopUpProps> = ({ children, show }) => {
  return (
    <>
      {show ? (
        <div className="flex items-start justify-center fixed top-0 w-full min-h-screen bg-black z-50 bg-opacity-70 px-3 pt-5 pb-32 lg:py-5 max-h-full overflow-y-auto">
          {children}
        </div>
      ) : null}
    </>
  );
};

export default PopUp;
